// The action bar's targeting step (issue 1130; design/29 §2.1): "Mary selects Shelby, chooses Longsword and taps the
// ogre". Picking an attack on the bar puts the board in this mode; the next tap on a token is handed to the bar, which
// sends the attack — the tap selects nothing and drags nothing. One board mode at a time: starting it stops every
// other tool, and every other tool stops it. Held outside React, like the pointing tool.
import { wallTool } from './wallTool';
import { areaTool } from './areaTool';
import { drawTool } from './drawTool';
import { focusTool } from './focusTool';
import { fogTool } from './fogTool';
import { zoneTool } from './zoneTool';
import { measureTool } from './measureTool';
import { whatsThisTool } from './whatsThisTool';

export interface Targeting { on: boolean; /** What the bar says it is picking a target for. */ label: string }

type Listener = (t: Targeting) => void;
let state: Targeting = { on: false, label: '' };
let onPick: ((id: string) => void) | null = null;
const listeners = new Set<Listener>();
const set = (next: Targeting) => { state = next; for (const l of listeners) l(state); };

export const targetTool = {
  get: () => state,
  subscribe(listener: Listener): () => void { listeners.add(listener); return () => { listeners.delete(listener); }; },
  start(label: string, pick: (id: string) => void): void {
    focusTool.stop(); measureTool.stop(); areaTool.stop(); fogTool.stop(); drawTool.stop(); wallTool.stop(); zoneTool.stop(); whatsThisTool.stop();
    onPick = pick;
    set({ on: true, label });
  },
  stop(): void { onPick = null; if (state.on) set({ on: false, label: '' }); },
  /** A tap on a token: handed to the bar, and the mode ends. */
  pick(id: string): void { const f = onPick; targetTool.stop(); f?.(id); },
};
